import { EmptyTextData } from 'library/types';

import { StyledLink } from './CustomLink';

export const EmailLink = ({
	email,
}: {
	email: EmptyTextData;
}): React.JSX.Element | null =>
	email ? (
		<StyledLink title={email} href={`mailto:${email}`} color="secondary">
			{email}
		</StyledLink>
	) : null;
